import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _70fbf098 = () => interopDefault(import('../pages/about-us/index.vue' /* webpackChunkName: "pages/about-us/index" */))
const _9b56e62e = () => interopDefault(import('../pages/contacts/index.vue' /* webpackChunkName: "pages/contacts/index" */))
const _21226ff0 = () => interopDefault(import('../pages/es-projektai/index.vue' /* webpackChunkName: "pages/es-projektai/index" */))
const _7c3bd26d = () => interopDefault(import('../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _f39cff60 = () => interopDefault(import('../pages/projects/index.vue' /* webpackChunkName: "pages/projects/index" */))
const _ab582998 = () => interopDefault(import('../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _f70a41f0 = () => interopDefault(import('../pages/projects/_slug.vue' /* webpackChunkName: "pages/projects/_slug" */))
const _aec56c28 = () => interopDefault(import('../pages/services/_slug.vue' /* webpackChunkName: "pages/services/_slug" */))
const _399072cf = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _70fbf098,
    name: "about-us"
  }, {
    path: "/contacts",
    component: _9b56e62e,
    name: "contacts"
  }, {
    path: "/es-projektai",
    component: _21226ff0,
    name: "es-projektai"
  }, {
    path: "/privacy-policy",
    component: _7c3bd26d,
    name: "privacy-policy"
  }, {
    path: "/projects",
    component: _f39cff60,
    name: "projects"
  }, {
    path: "/services",
    component: _ab582998,
    name: "services"
  }, {
    path: "/projects/:slug",
    component: _f70a41f0,
    name: "projects-slug"
  }, {
    path: "/services/:slug",
    component: _aec56c28,
    name: "services-slug"
  }, {
    path: "/",
    component: _399072cf,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
